import React, { lazy } from 'react';
import IconException from '@/assets/images/menu/icon-exception.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const errorRoutes = (): IRouteConfig[] => [
  {
    path: '/exception/error',
    name: '错误',
    icon: <MenuIcon icon={IconException} fontSize={16} />,
    sort: 95,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.Flutter,
      CapitalPlatform.IOS,
      CapitalPlatform.HarmonyOS,
      CapitalPlatform.Mac,
      CapitalPlatform.Windows,
      CapitalPlatform.VisionOS,
      CapitalPlatform.AppleTV,
    ],
    routes: [
      {
        path: '/exception/error/dashboard',
        name: '概览',
        component: lazy(() => import('@/presentation/pages/error/dashboard')),
      },
      {
        path: '/exception/error/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/error/issues/list')),
      },
      {
        path: '/exception/error/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/error/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/error/caller/detail',
        name: '调用方详情',
        platforms: [CapitalPlatform.Android, CapitalPlatform.HarmonyOS],
        component: lazy(() => import('@/presentation/pages/anr/caller-detail')),
        hideInMenu: true,
        whitelisted: true,
      },
    ],
  },
];

export default errorRoutes;
